import { Flex } from "@chakra-ui/react";
import RightContent from "./RightContent";

export default function HomeContent() {
    return (
        <Flex>
            <RightContent />
        </Flex >
    );
}